import { useModel } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, ContentSubheaderView, PageContainer, PageContentView } from 'components/shared';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import React from 'react';
import "./styles.css";
/**
 * @function ExternalTransfersPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ExternalTransfersPage
 */
export default function ExternalTransfersPage(props) {
  const { branding } = useModel();
  const { options } = branding;
  const demo = branding.options.tn_version_abi22 === "Legacy" ? "TNLegacy" : "TN19";
  const subheaderText = options.externaltransfers_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  const mabiBranding = window.mabi23Branding;
  const option = mabiBranding
    ? mabiBranding.options.integrated_page_header_mabi23
    : options.integrated_page_header_abi22;
  const showHeader = option !== "false";

  return (
    <PageContainer className="external-transfers-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
        <CenterContentContainer>
          { showHeader && <ContentHeaderView text="External Transfers"/> }

          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          {/* iFrame for TN19 goes here */}
          <ExternalIframe demo={ demo } className="external-transfers-iframe"  key ="ExternalTransfersPage"/>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
